import type {
  Market,
  SupportReasonCode,
  TicketSource,
  TicketStatus,
} from '../dataProvider/types';

/** Display helpers and guardrail constants for the Ticket inbox and the bounded
 *  support credit (D-ticket-inbox, D-support-role, the Phase 6 lead). */

export const TICKET_STATUS_LABEL: Record<TicketStatus, string> = {
  open: 'Open',
  pending: 'Pending',
  resolved: 'Resolved',
  escalated: 'Escalated',
};

export const TICKET_STATUS_COLOR: Record<
  TicketStatus,
  'default' | 'warning' | 'info' | 'success' | 'error'
> = {
  open: 'warning',
  pending: 'info',
  resolved: 'success',
  escalated: 'error',
};

export const TICKET_SOURCE_LABEL: Record<TicketSource, string> = {
  user_initiated: 'Member raised',
  system_generated: 'System raised',
};

export const SUPPORT_REASON_LABEL: Record<SupportReasonCode, string> = {
  goodwill: 'Goodwill',
  missed_cashback: 'Missed cashback',
  refund: 'Refund',
  service_failure: 'Service failure',
  other: 'Other',
};

/**
 * The per-credit SUPPORT cap (D-support-role), per market in the market's currency.
 * It is DELIBERATELY LOWER than the super_admin ADJUSTMENT_CAP: a support agent
 * handling volume must never move a large sum. Like the adjustment cap it is a
 * confirm-gate, not a permission: a credit whose amount reaches the cap goes through a
 * deliberate confirmation that shows the figure before it commits. [REVIEW] the values
 * with the finance team as real support-credit volumes land.
 */
export const SUPPORT_CREDIT_CAP: Record<Market, number> = {
  uk: 500,
  us: 500,
  ie: 500,
};
